// dependencies
import Cookies from '_lib/cookies'

const querystring = require('query-string')
class API {
  constructor(backend, config) {
    this.backend = backend
    this.config = config || {}
  }

  errorInterceptor({ error }, next) {
    return next(error)
  }

  // basic request
  request(resource, config, next) {
    // set default headers
    if (!config.headers) config.headers = {}
    config.headers['Accept'] = 'application/json'

    if (!config.formData) config.headers['Content-Type'] = 'application/json'

    const token =
      config.token ||
      this.token ||
      Cookies.getCookie('token')
    // check for authentication
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    // stringify body
    if (config.body && !config.formData && typeof config.body !== 'string') {
      config.body = JSON.stringify(config.body)
    }

    // FIX: Remove token from query string if present - should use Authorization header instead
    if (config.qs && config.qs.token) {
      delete config.qs.token
    }

    // encode querystring
    let qs = ''
    if (config.qs) {
      qs = querystring.stringify(config.qs)
      delete config.qs
      if (qs.length > 0) {
        qs = `?${qs}`
      }
    }

    // get url
    let url = ''
    if (resource.indexOf('http') === -1) {
      url = `${this.backend}${resource}${qs}`
    }
    if (resource.indexOf('http') !== -1) {
      url = `${resource}${qs}`
    }

    // if redirect
    if (config.redirect) {
      window.location.href = url
    }

    // make request
    else {
      fetch(url, config)
        .then((resp) => {
          return resp.json().then((data) => {
            if (resp.status.toString().startsWith('2')) {
              next(null, data)
            } else {
              return Promise.reject(data)
            }
          })
        })
        .catch((error) => {
          this.errorInterceptor({ error, api: this, url, config }, next)
        })
    }
  }

  delete(resource, body, next) {
    this.request(
      resource,
      {
        method: 'DELETE',
        body,
      },
      next
    )
  }

  get(resource, qs, next) {
    if (typeof qs === 'function') {
      next = qs
      qs = {}
    }
    this.request(
      resource,
      {
        method: 'GET',
        qs,
      },
      next
    )
  }

  patch(resource, body, next) {
    this.request(
      resource,
      {
        method: 'PATCH',
        body,
      },
      next
    )
  }

  post(resource, body, next, config) {
    this.request(
      resource,
      {
        method: 'POST',
        body,
        ...config,
      },
      next
    )
  }

  put(resource, body, next, config) {
    this.request(
      resource,
      {
        method: 'PUT',
        body,
        ...config,
      },
      next
    )
  }

  redirect(resource, qs, next) {
    if (typeof qs === 'function') {
      next = qs
      qs = {}
    }
    this.request(
      resource,
      {
        method: 'GET',
        qs,
        redirect: true,
      },
      next
    )
  }
}

// export
let getAPI = function (backend, config) {
  // create api
  let api = new API(backend, config)

  // done
  return api
}

// export api wrapper
export default getAPI
